import formatDate from './formatDate';
import verboseDate from './verboseDate';

const MINUTE = 60 * 1000;

const verboseTime = (isoDate) => {
  let date = new Date(isoDate);
  date = new Date(date.getTime() - (date.getTimezoneOffset() * MINUTE));

  return `${(`0${date.getHours()}`).slice(-2)}:${(`0${date.getMinutes()}`).slice(-2)} AM`;
};

export default (isoDate, l10n) => (
  isoDate && l10n
    ? `${verboseDate(formatDate(new Date(isoDate)), l10n)} - ${verboseTime(isoDate)}`
    : undefined
);
